import { Box, HStack, Text, VStack, IconButton, Grid } from "@chakra-ui/react";
import "../index.css";
import { Image } from "../reusables";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import useColorAccent from "../../hooks/useColorAccent";
import { Link } from "react-router";
import { FiArrowRight, FiPlay, FiTrash } from "react-icons/fi";
import { useHlsAudioActions } from "../../wrappers/hlsAudio";
import useReactiveQuery from "../../hooks/data/useReactiveQuery";
import dayjs from "../../helpers/dayJs";

const MotionBox = motion(Box);

/**
 *
 * @param {import("@chakra-ui/react").GridProps & {id: string, onRemove: () => void, variant: 'regular' | 'small'}} props
 *
 */
export default function PostListItem(props) {
  const { get } = useReactiveQuery();
  const { id, variant, onRemove, ...styleProps } = props;

  const post = get(["posts", id]);
  const [isContainerHovered, setIsContainerHovered] = useState(false);
  // const { actions } = useHlsAudio();
  const { playTrack } = useHlsAudioActions();

  const thumbnailFileName =
    post?.track?.thumbnails?.[post?.track?.thumbnails?.length - 1]?.fileName;

  const { attachImage, accentColor } = useColorAccent();
  const [isNameHovered, setIsNameHovered] = useState(false);

  const formatDuration = (durationSec = 0) => {
    return dayjs.utc(durationSec * 1000).format("m:ss");
  };

  return (
    <Grid
      gridTemplateColumns={
        variant === "small" ? "70px 1fr auto" : "90px 1fr auto"
      }
      // minH="75px"
      w="full"
      borderRadius={"md"}
      spacing={"2"}
      align={"flex-start"}
      pos={"relative"}
      columnGap={variant === "small" ? "3" : "5"}
      px="2"
      py="1.5"
      alignItems={"center"}
      _hover={{
        bg: "#30303640",
      }}
      cursor={"pointer"}
      onMouseEnter={() => setIsContainerHovered(true)}
      onMouseLeave={() => setIsContainerHovered(false)}
      role="group"
      onClick={() => playTrack(post)}
      minW="300px"
      {...styleProps}
    >
      <Box
        h="full"
        transition={"all 200ms"}
        // boxShadow={`0px 0px 10px 2px ${accentColor}60`}
        overflow={"hidden"}
        borderRadius={"md"}
        _hover={{
          transform: "scale(1.05)",
          boxShadow: `none`,
        }}
      >
        <Image
          firebaseStoragePath={
            thumbnailFileName
              ? `photos/${post?.user?.id}/${post?.id}/thumbnails/${thumbnailFileName}`
              : null
          }
          h="full"
          w="full"
        />
      </Box>
      <Grid w="full" h="full" gridTemplateRows={"1fr auto"} rowGap={"2"}>
        <VStack
          w="full"
          spacing={"0"}
          align={"flex-start"}
          justify={"flex-start"}
        >
          <Text
            noOfLines={"1"}
            fontSize={variant === "small" ? "sm" : "xl"}
            fontWeight={"bold"}
            _hover={{ textDecor: "underline" }}
            cursor={"pointer"}
            onMouseEnter={() => setIsNameHovered(true)}
            onMouseLeave={() => setIsNameHovered(false)}
            as={Link}
            to={`/user/${post?.user?.username}/post/${post?.id}`}
            onClick={(e) => e.stopPropagation()}
          >
            {post?.title}
          </Text>

          <Text color={"gray.400"} fontSize={variant === "small" ? "xs" : "sm"}>
            {post?.user?.fullName}
          </Text>
        </VStack>
        <AnimatePresence mode="wait">
          {!isContainerHovered ? (
            <MotionBox
              key="duration"
              initial={{ opacity: 0.9, translateY: -1 }}
              animate={{ opacity: 1, translateY: 0 }}
              exit={{ opacity: 0, translateY: -10 }}
              transition={{ ease: "linear", duration: 0.03 }}
            >
              <Text fontSize={"xs"} color="gray.400">
                {formatDuration(post?.duration)}
              </Text>
            </MotionBox>
          ) : (
            <MotionBox
              key="access_buttons"
              initial={{ opacity: 0, translateY: 10 }}
              animate={{ opacity: 1, translateY: 0 }}
              exit={{ opacity: 0, translateY: 10 }}
              transition={{ ease: "linear", duration: 0.07 }}
            >
              {!isNameHovered ? (
                <MotionBox
                  key="btn_play"
                  initial={{ opacity: 0, translateY: -10 }}
                  animate={{ opacity: 1, translateY: 0 }}
                  exit={{ opacity: 0, translateY: -10 }}
                  transition={{ ease: "linear", duration: 0.07 }}
                >
                  <HStack color={"gray.500"}>
                    <FiPlay size={13} />
                    <Text fontSize={"xs"}>Click to play</Text>
                  </HStack>
                </MotionBox>
              ) : (
                <MotionBox
                  key="btn_goToPost"
                  initial={{ opacity: 0, translateY: 10 }}
                  animate={{ opacity: 1, translateY: 0 }}
                  exit={{ opacity: 0, translateY: 10 }}
                  transition={{ ease: "linear", duration: 0.07 }}
                >
                  <HStack color={"gray.500"}>
                    <FiArrowRight size={13} />
                    <Text fontSize={"xs"}>View track</Text>
                  </HStack>
                </MotionBox>
              )}
            </MotionBox>
          )}
        </AnimatePresence>
      </Grid>
      {onRemove && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          size="sm"
          icon={<FiTrash />}
          variant={"nav"}
          opacity={0}
          _groupHover={{
            opacity: 1,
          }}
        />
      )}
    </Grid>
  );
}
